import axios from 'axios';
import { Response, ResponseArray } from '../../../../setup/axios/HttpResponse';
import { API_URL } from '../../../utils/common/constants';
import { AddressByLatLngRequest, CreateCustomerRequest, CustomerSearchRequest, CustomerSearchResponse, MapLocation, CustomerTicketStatisticModel, CustomerSearchCreateOrderRequest, CustomerSearchCreateOrderResponse, CustomerSearchCreateOrderModel, CustomerSearchModel, UpdateCustomerRequest, Province, District, AddCustomerAddressRequest, RabbitMQPublishResponse, GpsDeniedMessage } from '../models';

const customerApi = {
    convertUrlLocation(payload: string, isToastMessage: boolean = true): Promise<Response<MapLocation>> {
        const url = `${API_URL}/api/v1/users/get-location-by-google-map-url?googleMapUrl=${payload}`
        return axios.get(url, { 'headers': { 'toast-message': isToastMessage } });
    },
    resolveUrl(url: string): Promise<Response<MapLocation>> {
        const apiUrl = `${API_URL}/api/v1/location/resolve-url?url=${encodeURIComponent(url)}`;
        return axios.get(apiUrl, { headers: { 'toast-message': 'false' } });
    },
    getProvinces(): Promise<ResponseArray<Province>> {
        const url = `${API_URL}/api/v1/provine`
        return axios.get(url);
    },
    getDistrictsByProvince(provinceCode: string): Promise<ResponseArray<District>> {
        const url = `${API_URL}/api/v1/district/provine/${encodeURIComponent(provinceCode)}`
        return axios.get(url);
    },
    createCustomer(payload: CreateCustomerRequest): Promise<Response<string>> {
        const url = `${API_URL}/api/v1/customers`
        return axios.post(url, payload, { headers: { 'toast-message': 'false' } });
    },
    searchCustomer(payload: CustomerSearchRequest): Promise<Response<CustomerSearchResponse>> {
        const params = new URLSearchParams({
            page: payload.page.toString(),
            pageSize: payload.pageSize.toString(),
            Includes: 'all',
        });

        if (payload.keyword) {
            params.append('keyword', payload.keyword);
        }

        if (payload.isActive !== undefined) {
            params.append('isActive', payload.isActive.toString());
        }

        if (payload.orderBy) {
            params.append('orderBy', payload.orderBy);
        }

        const url = `${API_URL}/api/v1/customers?${params.toString()}`;
        return axios.get(url);
    },
    checkB8akCustomer(payload: string): Promise<Response<boolean>> {
        const url = `${API_URL}/api/v1/users/check-b8ak-customer?customerId=${payload}`
        return axios.get(url);
    },
    fetchAddressByLatLng(payload: AddressByLatLngRequest, isToastMessage: boolean = true): Promise<Response<string>> {
        const url = `${API_URL}/api/v1/location/get-address-by-lat-lng?lat=${payload.lat}&lng=${payload.lng}`;
        return axios.get(url, { 'headers': { 'toast-message': isToastMessage } });
    },
    getCustomerTicketStatistic(payload: string, isToastMessage: boolean = true): Promise<Response<CustomerTicketStatisticModel>> {
        const url = `${API_URL}/api/v1/users/customer-ticket-statistic?customerId=${payload}`;
        return axios.get(url, { 'headers': { 'toast-message': isToastMessage } });
    },
    searchCustomerCreateOrder(payload: CustomerSearchCreateOrderRequest): Promise<Response<CustomerSearchCreateOrderModel>> {
        const url = `${API_URL}/api/v1/users/search-customer-create-order?keyword=${payload.keyword}&page=${payload.page}&pageSize=${payload.pageSize}&isSearchCustomer=${payload.isSearchCustomer}`; // Fixed: was payload.keyword
        return axios.get(url);
    },

    getCustomerById(customerId: string): Promise<Response<CustomerSearchModel>> {
        const url = `${API_URL}/api/v1/customers/${customerId}?includes=all`;
        return axios.get(url);
    },
    // TODO: to be changed
    updateCustomer(customerId: string, payload: UpdateCustomerRequest): Promise<Response<string>> {
        const url = `${API_URL}/api/v1/customers/${customerId}`;
        return axios.put(url, payload, { headers: { 'toast-message': 'false' } });
    },
    toggleBlockCustomer(customerId: string, isBlocked: boolean): Promise<Response<string>> {
        const url = `${API_URL}/api/v1/customers/${customerId}/toggle-block`;
        return axios.put(url, { isBlocked }, { headers: { 'toast-message': 'false' } });
    },
    addCustomerAddress(customerId: string, payload: AddCustomerAddressRequest): Promise<Response<string>> {
        const url = `${API_URL}/api/v1/customers/${customerId}/address`;
        return axios.post(url, payload, { headers: { 'toast-message': 'false' } });
    },
    updateCustomerAddress(customerId: string, addressId: string, payload: AddCustomerAddressRequest): Promise<Response<string>> {
        const url = `${API_URL}/api/v1/customers/${customerId}/address/${addressId}`;
        return axios.put(url, payload, { headers: { 'toast-message': 'false' } });
    },
    requestLocation(payload: any): Promise<Response<string>> {
        const url = `${API_URL}/api/v1/users/confirms-location`
        return axios.post(url, {
            customerId: payload.customerId,
            link: payload.link,
            customerPhone: payload.customerPhone,
            addressId: payload.addressId
        });
    },
    /**
     * Publish GPS denied message to RabbitMQ
     * Backend will publish message to RabbitMQ queue
     */
    publishGpsDeniedMessage(payload: GpsDeniedMessage): Promise<Response<RabbitMQPublishResponse>> {
        const url = `${API_URL}/api/v1/users/location-access-denied`
        return axios.post(url, {
            code: payload.code,
            token: payload.token,
            clientTimeOffset: payload.clientTimeOffset
        });
    },
    /**
     * Import customers from Excel file
     */
    importCustomersFromExcel(formData: FormData): Promise<Response<any>> {
        const url = `${API_URL}/api/v1/customers/import-customers-from-excel`;
        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    /**
     * Download customer import template
     */
    downloadCustomerTemplate(): Promise<Blob> {
        const url = `${API_URL}/api/v1/customers/download-customer-template`;
        return axios.get(url, {
            responseType: 'blob',
        });
    },
};


export { customerApi };